export function setupDaVinci() {
    return
    let div = document.createElement("div")
    div.id = "davinci"
    div.style.position = "fixed"
    div.style.bottom = "4px";
    div.style.right = "4px";
    div.style.borderRadius = "4px";
    div.style.background = "black";
    div.style.padding = "1px 8px";
    div.style.fontFamily = "monospace";
    div.style.fontSize = "12px";
    div.style.zIndex = "9999";
    div.style.color = "white";

    document.body.appendChild(div)

    let host = window.location.host;
    let url = `ws://${host}/davinci-ws`
    let socket = new WebSocket(url);
    div.innerHTML = "connecting..."


    let currentSize = "xl";

    window.addEventListener("resize", () => {
        div.innerHTML = div.innerHTML.substring(0, div.innerHTML.length - currentSize.length - 3 - 8)
        if (window.innerWidth < 768) {
            currentSize = "sm"
        } else if (window.innerWidth < 1024) {
            currentSize = "md"
        } else if (window.innerWidth < 1280) {
            currentSize = "lg"
        } else if (window.innerWidth < 1536) {
            currentSize = "xl"
        } else {
            currentSize = "2xl"
        }
        div.innerHTML += " - " + currentSize + " - " + Math.floor(window.innerWidth / 16) + "rem"
    })

    socket.onopen = () => {
        console.log('Connected to DaVinci reloaded server');

        div = document.querySelector("#davinci") as HTMLDivElement;
        div.innerHTML = "connected" + " - " + currentSize + " - " + Math.floor(window.innerWidth / 16) + "rem"
    };
    socket.onclose = () => {
        setTimeout(() => {
            socket = new WebSocket(url);
        }, 1000)
        div.innerHTML = "closed"

    }

    socket.onerror = () => {
        setTimeout(() => { window.location.reload() }, 5000)
        div.innerHTML = "error"
    }

    socket.onmessage = (event) => {
        console.log(event)
        if (event.data === 'template_changed') {
            console.log('Templates have changed, reloading page...');
            div.innerHTML = "reloading..."
            // reload this page
            window.location.reload()
        }
    };

};
